










// Vue
import { defineComponent, PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'Button',
  props: {
    size: {
      type: String as PropType<'lg'|'md'|'sm'>,
      default: 'sm'
    },
    color: {
      type: String as PropType<string>,
      default: 'primary'
    },
    type: {
      type: String,
      default: 'button'
    }
  }
})
